module.exports = __webpack_public_path__ + "img/hrvoje_rubesa.c4b83469.jpg";